import { createAction } from '@reduxjs/toolkit';
import { SharingLink, UpdateSharingLinkParams } from '../../api';
import { SharingLinkShape } from './model';

export const loadLinksRequested = createAction('al/sharingLink/loadLinksRequested');

export const setLoading = createAction<{ loading: boolean }, 'al/sharingLink/setLoading'>(
  'al/sharingLink/setLoading',
);

export const linksChanged = createAction<
  { links: SharingLinkShape['links']; total: SharingLinkShape['pagination']['total'] },
  'al/sharingLink/linksChanged'
>('al/sharingLink/linksChanged');

export const deleteClicked = createAction<void, 'al/sharingLink/deleteClicked'>(
  'al/sharingLink/deleteClicked',
);

export const activateClicked = createAction('al/sharingLink/activateClicked');

export const linksSelected = createAction<
  { ids: SharingLink['id'][] },
  'al/sharingLink/linksSelected'
>('al/sharingLink/linksSelected');

export const linkChanged = createAction<{ link: SharingLink }, 'al/sharingLink/linkChanged'>(
  'al/sharingLink/linkChanged',
);

export const linkModalSetVisible = createAction<
  { visible: true; link: SharingLink } | { visible: false },
  'al/sharingLink/linkModalSetVisible'
>('al/sharingLink/linkModalSetVisible');

export const linkModalSetInProgress = createAction<
  { inProgress: boolean },
  'al/sharingLink/linkModalSetInProgress'
>('al/sharingLink/linkModalSetInProgress');

export const linkModalSubmitted = createAction<
  UpdateSharingLinkParams,
  'al/sharingLink/linkModalSubmitted'
>('al/sharingLink/linkModalSubmitted');

export const searchQueryChanged = createAction<{ searchQuery: string }>(
  'al/sharingLink/searchQueryChanged',
);

export const sorterChanged = createAction<SharingLinkShape['sorter']>(
  'al/sharingLink/sorterChanged',
);

export const isActiveFilterChanged = createAction<{
  isActive: SharingLinkShape['isActiveFilter'];
}>('al/sharingLink/isActiveFilterChanged');

export const paginationChanged = createAction<{ current: number }>(
  'al/sharingLink/paginationChanged',
);
